import { Filter } from "@auditcloud/shared/lib/utils/filter/types";

export class AddAuditItemDialogState {
  activeFilter: Filter[] = [];
  fulltextSearch: string = "";
}
export type State = AddAuditItemDialogState;
